import * as classNames from 'classnames';
import * as React from 'react';
import withStyles, { StyledComponentProps } from 'react-jss';
import ViewMonitor from './ViewMonitor';

const styles = {
    container: {
        opacity: 0,
        transition: 'transform .3s ease-out, opacity .7s linear'
    },
    containerUp: {
        transform: 'translate3d(0,50px,0)',
    },
    containerDown: {
        transform: 'translate3d(0,-50px,0)',
    },
    visible: {
        opacity: 1,
        transform: 'translate3d(0,0,0)'
    }
};

type Props =
    StyledComponentProps<keyof typeof styles> &
    React.HTMLAttributes<HTMLElement>;

const FadeInUp: React.FunctionComponent<Props> = (props) => {
    const { children, classes, ...rest } = props;

    return (
        <ViewMonitor>
            {(visible, direction) =>
                <div {...
                    {
                        ...rest,
                        className: classNames(
                            rest.className, 
                            classes!.container, 
                            direction === 'down' ? classes!.containerUp : classes!.containerDown,
                            visible && classes!.visible
                        )
                    }
                }
                >
                    {children}
                </div>
            }
        </ViewMonitor>
    );
}
export default withStyles(styles)(FadeInUp);


// WEBPACK FOOTER //
// ./src/utils/FadeInUp.tsx